import { TaggedError } from "../tagged-error.js";
export class InvalidEmailValidationTokenError extends TaggedError {
    constructor() {
        super("InvalidEmailValidationTokenError");
    }
}
